export const API_URL = 'https://userapi.anypay.my/web-api'
export const APP_KEY = 'yDq63tjiKGIP3DyZRstBXJ/PsMKGYscUNkExImizb5w='
export default { API_URL, APP_KEY }
